import React, { useEffect, useState } from "react";
import { ICON } from "../../../assets";
import { price } from "../../../utils";
import UiIcon from "../UiIcon";
import "./UiProgressBar.css";

const UIBarColors = {
  brand: "#FCA2AD",
  lightCream: "#F4D5B7",
};

const UiProgressBar = ({ barConfig }) => {
  const [bar, setBar] = useState([]);
  const [steps, setSteps] = useState([]);
  const [progressPercentage, setProgressPercentage] = useState(0);
  useEffect(() => {
    let barFillPercentage = (barConfig.barValue / barConfig.totalValue) * 100;
    const targets = barConfig.targets;
    const totalValueofTargets = targets.reduce((a, b) => (a += b.value), 0);
    setProgressPercentage((totalValueofTargets / barConfig.totalValue) * 100);
    let barArr = [];
    for (let i = 0; i < targets.length; i++) {
      const target = targets[i];
      const targetPercentage = (target.value / barConfig.totalValue) * 100;
      if (barFillPercentage > 0) {
        if (barFillPercentage >= targetPercentage) {
          barArr.push({
            width: `${targetPercentage}%`,
            color: target.color,
          });
          barFillPercentage -= targetPercentage;
        } else {
          barArr.push({
            width: `${barFillPercentage}%`,
            color: target.color,
          });
          barFillPercentage = 0;
        }
      }
    }

    let stepArr = [];
    for (let j = 0; j < targets.length; j++) {
      const target = targets[j];
      const targetPercentage = (target.value / totalValueofTargets) * 100;
      stepArr.push({
        width: `${targetPercentage}%`,
        offerValue: price(target.offerValue) + " €",
        label: target.label,
      });
    }

    for (let i = 0; i < stepArr.length; i++) {
      const stepWidth = stepArr[i]?.width.replace("%", "");
      const barWidth = barArr[i]?.width.replace("%", "");
      if (parseFloat(barWidth) >= parseFloat(stepWidth)) {
        stepArr[i]["targetAchieved"] = true;
      } else {
        stepArr[i]["targetAchieved"] = false;
      }
    }

    setBar(barArr);
    setSteps(stepArr);
  }, [barConfig]);

  return (
    <React.Fragment>
      <div className="ui-progress-bar-main">
        <div
          className="ui-progress-bar"
          style={{ width: `${progressPercentage}%` }}
        >
          <div className="ui-progress-bar-container">
            {bar.length != 0 &&
              bar?.map((b, i) => (
                <React.Fragment key={i}>
                  <span
                    className="ui-progress-bar-fill"
                    style={{ width: b.width, backgroundColor: b.color }}
                  ></span>
                </React.Fragment>
              ))}
          </div>
          <div className="ui-progress-bar-steps">
            {steps.length != 0 &&
              steps?.map(
                (s, i) =>
                  s.offerValue && (
                    <React.Fragment key={i}>
                      <div style={{ width: s.width }}>
                        {i != steps.length - 1 && (
                          <div className="ui-progress-bar-step">
                            <div className="ui-progress-bar-step-info">
                              <UiIcon
                                icon={ICON.topArrowIndicatorIcon}
                                size="md"
                              />
                              <span className="ui-progress-bar-step-target">
                                {s.targetAchieved && (
                                  <UiIcon icon={ICON.CheckIcon} size="xs" />
                                )}
                                {s.offerValue}
                              </span>
                              <span className="ui-progress-bar-step-label">
                                {s.label}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </React.Fragment>
                  ),
              )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UiProgressBar;
export { UIBarColors };

// note barConfig structure
// barConfig {
//               barValue: 500, // current value  ,
//               totalValue: 200 , // target value
//               targets: [
//                 {
//                   value: 100, // target value one
//                   offerValue: 100, // offer value on target one
//                   label: "commande minimale",
//                   color: UIBarColors.brand,
//                 },
//                 {
//                   value: 200 - 100, // target value two  but should be totalValue - value of target one
//                   offerValue: 200, // offer value on target two
//                   label: "frais de livraison offerts",
//                   color: UIBarColors.lightCream,
//                 },
//               ],
//             }
